import React, {useEffect, useState} from 'react';
import {login} from '../../services/userService';
import {useCookies} from "react-cookie";
import axiosInstance from "../../api";
import jwt_decode from "jwt-decode";
import {isTokenValid, removeSession} from "../../utils/sessionUtils";
import Spinner from "../../components/Spinner";
import {useUserContext} from "../../context/UserContext";
import {useHistory} from "react-router-dom";
import {Alert} from "@material-ui/lab";
import {Box} from "@material-ui/core";

import { loginRequest } from "../../authConfig";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import {
  EventMessage,
  EventType,
  PublicClientApplication,
} from "@azure/msal-browser";

export default function Login() {
  const history = useHistory();
  const [showSpinner, setShowSpinner] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [cagCookie, setCookie, removeCookie] = useCookies([
    "cag_login_context_path",
    "fmap_login_context_path",
  ]);
  const { user, dispatch } = useUserContext();
  const { instance, accounts } = useMsal();
  const [jwtToken, setJwtToken] = useState(null);

  useEffect(() => {
    console.log("Login Page", window.location);
    if (accounts.length === 0) {
      instance.loginRedirect(loginRequest);
      history.push("/");
    }
  }, []);

  return (
    <>
      {!errorMessage && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "50px",
          }}
        >
          <h2>Redirecting.....</h2>
        </div>
      )}
      {errorMessage && (
        <Box>
          <div>
            <br />
            <Alert variant="filled" severity="error">
              {errorMessage}
            </Alert>
          </div>
        </Box>
      )}
    </>
  );
}
